export default __webpack_public_path__ + "assets/empty-notification-sidebar.png";